import { CONCEPT_CATALOG } from "./conceptCatalog";
import { validPassageId } from "./conceptIndex";
import type { ConceptSelection } from "./ConceptView";
export type ConceptDestination = { mode: "concepts" | "study" | "battle" | "exam" | "life"; passageId?: number; examId?: string; libraryView?: string };
export type ConceptNavigation = ConceptDestination & { selection: ConceptSelection };
export function validateConceptNavigation(value: unknown): ConceptNavigation | null {
  if (!value || typeof value !== "object") return null;
  const v = value as Partial<ConceptNavigation>, c = v.selection;
  if (!c || typeof c.query !== "string" || !c.query.trim() || c.query.length > 40 || !["literal", "reviewed"].includes(c.kind) || !Number.isInteger(c.book) || c.book < 0 || c.book > 20 || !["concepts", "study", "battle", "exam", "life"].includes(v.mode ?? "")) return null;
  const result: ConceptNavigation = { mode: v.mode!, selection: { query: c.query, kind: c.kind, book: c.book, anchor: validPassageId(c.anchor) } };
  if (v.passageId !== undefined) { const id = validPassageId(v.passageId); if (!id) return null; result.passageId = id; }
  if (v.examId !== undefined) { if (typeof v.examId !== "string" || v.examId.length > 100) return null; result.examId = v.examId; }
  if (v.libraryView !== undefined) { if (!["numbers", "people", "life", "notebook"].includes(v.libraryView)) return null; result.libraryView = v.libraryView; }
  // A free literal query may not be a catalog entry. Reviewed mode truthfully
  // renders an empty result until an editorial entry exists.
  if (c.kind === "reviewed" && !CONCEPT_CATALOG.some(item => item.label === c.query)) result.selection.kind = "literal";
  return result;
}
export function readConceptNavigation(): ConceptNavigation | null {
  try { return validateConceptNavigation(window.history.state?.analectsConcept); } catch { return null; }
}
export function writeConceptNavigation(value: ConceptNavigation, push: boolean) {
  try {
    const state = { ...window.history.state, analectsConcept: value };
    if (push) window.history.pushState(state, ""); else window.history.replaceState(state, "");
  } catch { /* The explicit return control remains usable without history. */ }
}
